import type Mithril from 'mithril';
import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';

export interface BannerHeroAttrs {
  url?: string;
  link?: string;
  title?: string;
  content?: string;
  className?: string;
}

/**
 * The `WelcomeHero` component displays a hero that welcomes the user to the
 * forum.
 */
export default class BannerHero extends Component<BannerHeroAttrs> {
  oninit(vnode: Mithril.Vnode<BannerHeroAttrs, this>) {
    super.oninit(vnode);
  }

  view(vnode: Mithril.Vnode<BannerHeroAttrs, this>) {
    const {
      url,
      link,
      title, // = app.forum.attribute('welcomeTitle'),
      content, // = m.trust(app.forum.attribute('welcomeMessage')),
      className,
    } = this.attrs;

    const style = {
      '--banner-url': url && `url(${url})`,
    };

    const onclick = () => {
      if (link) {
        window.open(link);
      }
    };

    return (
      <header className={classList('Hero BannerHero', className)} style={style} onclick={onclick}>
        <div className="container">
          <div className="containerNarrow">
            <h1 className="Hero-title">{title}</h1>
            <div className="Hero-subtitle">{content}</div>
          </div>
        </div>
      </header>
    );
  }
}
